import TableHeader from "./TableHeader";
import TableRows from "./TableRows";
import VerticalRows from "./VerticalRows";

export type ColumnDefinitionType<T, K extends keyof T> = {
  key: K;
  inputType: string;
  header: string;
  width?: number;
  textStyle?: string;
  colSpan?: number;
  isNumberField?: boolean;
  isWide?: boolean;
  editAsAdminOnly?: boolean;
};

export type TableProps<T, K extends keyof T> = {
  handleChange: any;
  data: Array<T>;
  columns: Array<ColumnDefinitionType<T, K>>;
  removeRow: (id: number) => void;
  addRow: () => void;
  footer?: {
    enabled: boolean;
    footerData: any;
  };
  children?: JSX.Element | JSX.Element[];
  isAdmin: boolean;
  rowActionsAsAdminOnly?: boolean;
  useVerticalRows?: boolean;
  entityName?: string
};

const tableClassName =
  "mt-4 table-auto w-full self-center justify-center justify-items-center text-center";

const Table = <T, K extends keyof T>({
  data,
  columns,
  removeRow,
  addRow,
  footer,
  handleChange,
  children,
  isAdmin,
  rowActionsAsAdminOnly,
  useVerticalRows,
  entityName
}: TableProps<T, K>): JSX.Element => {
  const showRowActions = !rowActionsAsAdminOnly || isAdmin
  return (
    <table className={tableClassName}>
      <TableHeader addRow={addRow} columns={columns} showRowActions={showRowActions} hideColumns={useVerticalRows}/>
      {
        useVerticalRows ? (
          <VerticalRows
            addRow={addRow}
            handleChange={handleChange}
            data={data}
            columns={columns}
            removeRow={removeRow}
            isAdmin={isAdmin}
            showRowActions={showRowActions}
            entityName={entityName}
          />
        ):
        (
          <TableRows
            addRow={addRow}
            handleChange={handleChange}
            data={data}
            columns={columns}
            removeRow={removeRow}
            isAdmin={isAdmin}
            showRowActions={showRowActions}
          />
        )
      }
      
      {footer?.enabled && children}
    </table>
  );
};

export default Table;
